import { React, useEffect, useState, useRef } from 'react'
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import axios from 'axios';
import { redirect, useNavigate } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssredirectToLogout
import { getCookie } from '../../utils/attribution';

function readStoredCartTotal() {
    const storedCartItems = localStorage.getItem('totalCartItems');

    if (!storedCartItems) {
        return "";
    }

    try {
        const parsedCartItems = JSON.parse(storedCartItems);
        const numCartItems = Object.values(parsedCartItems);
        const sum = numCartItems.reduce((accumulator, currentValue) => accumulator + Number(currentValue || 0), 0);
        return sum || "";
    } catch (error) {
        return "";
    }
}






export default function Searchbar(prop) {
    const S3_IMAGES = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/"
    const wc_url = "https://extremeperformance.com/wordpress";
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const S3_IMAGES_local = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/local_images/";
    let { setValueMenuSideBar, cartItemsdata, showOpenModel } = prop;
    const navigate = useNavigate();

    // const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
    const [vehicalDetails, setVehicalDetails] = useState(() => {
        return JSON.parse(localStorage.getItem('vehical_details') || '{}');
    });

    const userEmail = JSON.parse(localStorage.getItem('user_email'));
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const userLogout = params.get('logout');
    const paramName = params.get('redirected');



    const [totalCartItemsValue, setTotalCartItemsValue] = useState(() => cartItemsdata ? cartItemsdata : readStoredCartTotal());
    const [searchInputs, setSearchInput] = useState('');
    const [loader, setLoader] = useState(false);
    const [dataYear, setDataYear] = useState('');
    const [dataMake, setDataMake] = useState('');
    const [dataModel, setDataModel] = useState('');
    const [dataModelVarient, setDataVarient] = useState('');
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "Year");
    const [selectedMake, setSelectedMake] = useState(vehicalDetails ? vehicalDetails.make : "");
    const [selectedModel, setSelectedModel] = useState(vehicalDetails ? vehicalDetails.model : "");
    const [selectedVariant, setSelectedVariant] = useState(vehicalDetails ? vehicalDetails.variant : "");

    // const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [selectedMakeName, setSelectedMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "Make");
    const [selectedModelName, setSelectedModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "Model");
    const [selectedVariantName, setSelectedVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "Sub model");

    const [defaultyear, setdefaultyear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [defaultMakeName, setdefaultMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "");
    const [defaultModelName, setdefaultModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "");
    const [defaultVariantName, setdefaultVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "");
    // const [defaultSearchType, setDefaultSearchType] = useState(vehicalDetails ? vehicalDetails.searchType : "");


    const [vehicalSearchOptions, setVehicalSearchOptions] = useState([]);
    const [selectedVehicalSearch, setSelectedVehicalSearch] = useState(null);
    const [selectedVehicalSearchName, setSelectedVehicalSearchName] = useState(null);
    const [isOpenVehicalSearch, setIsOpenVehicalSearch] = useState(false);
    const vehicalSearchRef = useRef(null);


    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMake, setIsLoadingMake] = useState(true);
    const [isLoadingModel, setIsLoadingModel] = useState(true);
    const [isLoadingVarient, setIsLoadingVarient] = useState(true);
    const [inStock, setInStock] = useState(true);


    const [isLoaderMake, setIsLoaderMake] = useState(true);
    const [isLoaderModel, setIsLoaderModel] = useState(true);
    const [isLoaderVarient, setIsLoaderVarient] = useState(true);
    const [isLoaderAllData, setIsLoaderAllData] = useState(true);


    const [isOpenMake, setisOpenMake] = useState(false);
    const [isOpenModel, setisOpenModel] = useState(false);
    const [isOpenVarient, setisOpenVarient] = useState(false);

    const [showMake, setShowMake] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [showVarient, setShowVarient] = useState(false);


    const [alertshow, setAlertShow] = useState(false);


    const [showModal, setShowModal] = useState(false);
    const [showModalAccount, setShowModalAccount] = useState(false);


    const [showMenuSide, setShowMenuSide] = useState("")

    const [showSeachbar, setShowSeachbar] = useState("")


    const [showVehical, setShowVehical] = useState(false)

    // const [searchType, setSearchType] = useState("")
    const [searchParam, setSearchParam] = useState('all');
    const [searchConcept, setSearchConcept] = useState('All');
    const [isDropdownOpen, setDropdownOpen] = useState(false);

    const [sideActive, setSideActive] = useState('');



    const [showResult, setShowResult] = useState(false);
    const [searchedData, setSearchedData] = useState([]);
    const [searchedDataCount, setSearchedDataCount] = useState(0);
    const [isloading, setIsloading] = useState(false);
    const [isloadingSearch, setIsloadingSearch] = useState(false);
    const [searchLength, setSearchLength] = useState(0);

    const inputReference = useRef(null);
    const [isEmptyInput, setIsEmptyInput] = useState(true);

    const itemsPerPage = 10; // Number of items per page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageInStock, setCurrentPageInStock] = useState(1);
    const [currentPageAllItems, setCurrentPageAllItems] = useState(1);
    const [newpage, setNewPage] = useState();


    const [showLoginModel, setShowLoginModel] = useState(false);
    const [showRegisterModel, setShowRegisterModel] = useState(false);
    const [showClass, setShowClass] = useState(true);
    const [loggedIn, setLoggedIn] = useState(false);
    const [loginUrlCustomer, setLoginUrlCustomer] = useState("#");

    const makeRef = useRef(null);
    const modelRef = useRef(null);
    const variantRef = useRef(null);

    const [userEmailCheck, setUserEmailCheck] = useState("");

    const [isHiddenLine, setIsHiddenLine] = useState(false);

    const [showPassword, setShowPassword] = useState(true);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(true);
    const [setShowPasswordSigin, setShowPasswordSignin] = useState(true);


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [clearVehicle, setClearVehicle] = useState(false);






    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const togglePasswordVisibilityConfirm = () => {
        setShowPasswordConfirm((prevShowPassword) => !prevShowPassword);
    };


    const togglePasswordVisibilitySignin = () => {
        setShowPasswordSignin((prevShowPassword) => !prevShowPassword);
    };

    const onClickEdit = () => {
        setShowModal(true)
    }

    useEffect(() => {
        const handleVehicleUpdate = () => {
            const updatedDetails = JSON.parse(localStorage.getItem('vehical_details') || '{}');
            setVehicalDetails(updatedDetails);

            // Update ALL display-related states
            setdefaultyear(updatedDetails.year || "");
            setdefaultMakeName(updatedDetails.make_name || "");
            setdefaultModelName(updatedDetails.model_name || "");
            setdefaultVariantName(updatedDetails.variant_name || "");

            setSelectedYear(updatedDetails.year || "Year");
            setSelectedMake(updatedDetails.make || "");
            setSelectedModel(updatedDetails.model || "");
            setSelectedVariant(updatedDetails.variant || "");

            setSelectedMakeName(updatedDetails.make_name || "Make");
            setSelectedModelName(updatedDetails.model_name || "Model");
            setSelectedVariantName(updatedDetails.variant_name || "Sub model");
        };
        // Run once on mount
        handleVehicleUpdate();
        window.addEventListener('vehicleUpdated', handleVehicleUpdate);
        window.addEventListener('storage', (e) => {
            if (e.key === 'vehical_details') {
                handleVehicleUpdate();
            }
        });

        return () => {
            window.removeEventListener('vehicleUpdated', handleVehicleUpdate);
            window.removeEventListener('storage', handleVehicleUpdate);
        };
    }, []);



    const showAccountDetails = () => {
        setShowClass('')
        setShowClass(!showClass)
    }

    const handleClose = () => {
        setSelectedMakeName(vehicalDetails ? vehicalDetails.make_name : "Make")
        setSelectedModelName(selectedModelName)
        setSelectedVariantName(selectedVariantName)
        setShowPassword(true)
        setShowPasswordSignin(true)
        setShowPasswordConfirm(true)
        setShowModal(false)
        setisOpenMake(false);
        setisOpenModel(false);
        setisOpenVarient(false);
        setShowModalAccount(false)
        setShowLoginModel(false)
        setShowRegisterModel(false)
        setErrors({});
        setNewErrors({});
        setFormData({
            email: '',
            password: '',
        })
        setFormDataRegister({
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            confirmPassword: '',
        })

        setShowPasswordConfirm((prevShowPassword) => !prevShowPassword);
        setShowPassword((prevShowPassword) => !prevShowPassword);
        setShowPasswordSignin((prevShowPassword) => !prevShowPassword);
    }



    useEffect(() => {
        setUserEmailCheck(userEmail ? userEmail : "");
        fetchYearData();
        fetchCartItems();

        if (userLogout) {
            localStorage.removeItem('user_email');
            setLoggedIn(false);
        }
        if (paramName == 1) {
            localStorage.removeItem('totalCartItems');
            cartItemsdata = 0;
        }

    }, []);

    useEffect(() => {
        setTotalCartItemsValue(cartItemsdata ? cartItemsdata : readStoredCartTotal());
    }, [cartItemsdata]);

    useEffect(() => {
        const handleCartUpdated = () => {
            setTotalCartItemsValue(readStoredCartTotal());
        };

        window.addEventListener("cartUpdated", handleCartUpdated);

        return () => {
            window.removeEventListener("cartUpdated", handleCartUpdated);
        };
    }, []);





    const fetchCartItems = async () => {

        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/cart`,
                credentials: 'include', // Send cookies with the request
                withCredentials: true,
            };
            axios
                .request(config)
                .then((response) => {

                    if (response && response.data && response.data.allData.length < 1) {
                        // console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++', response.data)
                        localStorage.removeItem('totalCartItems');

                    }
                })
                .catch((error) => {
                    console.log(error);


                });
        } catch (error) {
            console.error('Error fetching data:', error);


        }
    };

    const fetchYearData = async () => {
        setIsLoading(true);
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getYear`,
            };
            axios
                .request(config)
                .then((response) => {
                    setDataYear(response.data);
                    setIsLoading(false);
                    if (selectedYear) {
                        fetchMakeData(selectedYear);
                    }

                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        }
    };

    const handleYearChange = (event) => {

        setisOpenVarient(false);
        setisOpenModel(false);
        const selectedYear = event.value
        if (selectedYear === "") {
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            setDataMake("")
            setDataModel("")
            setDataVarient("")

            setSelectedMakeName('')
            setSelectedModelName('')
            setSelectedVariantName('')

        } else {
            setSelectedYear(selectedYear);
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            fetchMakeData(selectedYear);
            setIsLoaderMake(false);
            setShowMake(true)
            setSelectedMakeName('')
            setSelectedModelName('')
            setSelectedVariantName('')
            setisOpenMake(true);
            makeRef.current?.focus();

        }

    };

    const fetchMakeData = async (selectedYear) => {

        if (selectedYear) {
            setIsLoadingMake(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getMakeByYear/${selectedYear}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        setIsLoadingMake(false);
                        setDataMake(response.data);
                        setIsLoaderMake(true);

                        if (selectedYear && selectedMake) {
                            fetchModelData(selectedYear, selectedMake);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingMake(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingMake(false);
            }
        }
    };

    const handleMakeChange = (event) => {
        setisOpenVarient(false);
        const selectedMake = event.value;
        const selectedMakeName = event.label;
        setSelectedMake(selectedMake);
        setSelectedMakeName(selectedMakeName);
        setisOpenMake(false)

        setDataModel([]);
        setSelectedModel('');
        setSelectedVariant('');

        setIsLoaderModel(false)
        fetchModelData(selectedYear, selectedMake);
        setShowModel(true)
        setisOpenModel(true)
        setSelectedModelName('')
        setSelectedVariantName('')
        modelRef.current?.focus();

    };

    const fetchModelData = async (selectedYear, selectedMake) => {
        if (selectedYear && selectedMake) {
            setIsLoadingModel(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getModelByMake/${selectedYear}/${selectedMake}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingModel(false);
                        setDataModel(response.data);
                        setIsLoaderModel(true)
                        if (selectedYear && selectedModel) {
                            fetchVariantData(selectedYear, selectedModel);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingModel(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingModel(false);
            }
        }
    };



    const fetchSearchData = async (searchTerm, cat, searchUpdate, searchCatUpdate, stock, stockCheck) => {
        try {

            const access_token = process.env.REACT_APP_ACCESS_TOKEN_SEARCH;

            const searchterm = encodeURIComponent(searchTerm)


            // console.log("currentPageInStock=======12113123",currentPageInStock)
            // console.log("currentPageAllItems=======12113123",currentPageAllItems)
            const type = "";
            // let config = {
            //     method: 'get',
            //     maxBodyLength: Infinity,
            //     url: `${mainUrl}/api/search/getallsearcheditems?searchTerm=${searchterm}&rootCategoryId=${cat ? cat : "all"}&type=${type}&page=${inStock ? currentPageInStock : currentPageAllItems}&stock=${stock ? "false" : 'true'}`,
            // };

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/search/getallsearcheditems?searchTerm=${searchterm}&rootCategoryId=${cat ? cat : "all"}&type=${type}&page=${inStock ? currentPageInStock : currentPageAllItems}&stock=${stock ? "false" : "true"}`,
                headers: {
                    // "x-api-key": "ab47728cbc830f2a49184caab45d1438a84b5da2"
                    "x-api-key": access_token
                }
            };

            const response = await axios.request(config);
            //     console.log("response++++++", response);
            if (inStock) {
                if (stockCheck) {
                    setSearchedData(response.data.data);
                } else {
                    if (!searchCatUpdate) {
                        if (searchedData.length > 0) {
                            if (searchUpdate) {
                                // Check if currentPage is not 1 to avoid duplicates on page 1

                                if (currentPageInStock !== 1) {
                                    //   console.log("currentPageInStock+++++++", currentPageInStock);
                                    setSearchedData(prevResults => [...prevResults, ...response.data.data]);
                                }



                            } else {
                                setSearchedData(response.data.data);
                            }
                        } else {
                            setSearchedData(response.data.data);
                        }
                    } else {
                        if (searchConcept !== "All") {
                            setSearchedData(response.data.data);
                        } else {
                            setSearchedData(response.data.data);
                        }
                    }
                }
                setIsloading(false);
                setIsloadingSearch(true);
                setSearchedDataCount(response.data.count);
            } else {
                if (stockCheck) {
                    setSearchedData(response.data.data);
                } else {
                    if (!searchCatUpdate) {
                        if (searchedData.length > 0) {
                            if (searchUpdate) {
                                // Check if currentPage is not 1 to avoid duplicates on page 1

                                if (currentPageAllItems !== 1) {
                                    // console.log("currentPageAllItems+++++++", currentPageAllItems);
                                    setSearchedData(prevResults => [...prevResults, ...response.data.data]);
                                }



                            } else {
                                setSearchedData(response.data.data);
                            }
                        } else {
                            setSearchedData(response.data.data);
                        }
                    } else {
                        if (searchConcept !== "All") {
                            setSearchedData(response.data.data);
                        } else {
                            setSearchedData(response.data.data);
                        }
                    }
                }
                setIsloading(false);
                setIsloadingSearch(true);
                setSearchedDataCount(response.data.count);

            }


        } catch (error) {
            console.log('Error fetching data:', error);
            setIsloading(false);
        }
    };



    const handleModelChange = (event) => {
        setisOpenModel(false);
        setisOpenVarient(false);

        const selectedModel = event.value;
        const selectedModelName = event.label;
        setSelectedModel(selectedModel);
        setSelectedModelName(selectedModelName);
        setSelectedVariant('');
        setSelectedVariantName('')
        // Fetch variant data based on selected year, make, and model
        fetchVariantData(selectedYear, selectedModel);
        setIsLoaderVarient(false)
        setShowVarient(true)
        setisOpenVarient(true)
        variantRef.current?.focus();
    };

    const fetchVariantData = async (selectedYear, selectedModel) => {
        if (selectedYear && selectedModel) {
            setIsLoadingVarient(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getSubModelByModel/${selectedYear}/${selectedModel}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingVarient(false);
                        setDataVarient(response.data);
                        setIsLoaderVarient(true)
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingVarient(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingVarient(false);
            }
        }
    };

    const handleVarientChange = (event) => {
        setisOpenVarient(false)
        const selectedVarient = event.value;
        const selectedVarientName = event.label
        setSelectedVariant(selectedVarient);
        setSelectedVariantName(selectedVarientName);

    };


    // const handleShow = () => {

    //     document.body.classList.remove('overflow_vehicle');
    //     let state = {
    //         year: selectedYear,
    //         make: selectedMake,
    //         model: selectedModel,
    //         variant: selectedVariant,
    //         make_name: selectedMakeName,
    //         model_name: selectedModelName,
    //         variant_name: selectedVariantName,
    //         // searchType: searchType,
    //     }
    //     // Save state in local storage
    //     localStorage.setItem('vehical_details', JSON.stringify(state));
    //     localStorage.removeItem('wheels_details');
    //     // Retrieve state from local storage  
    //     setTimeout(() => {
    //         navigate(`/categories-home/all-category`);
    //         window.location.reload();
    //     }, 1500); // Delay of 2000 milliseconds (2 seconds)s



    // };

    const handleReset = () => {
        setShowVehical(!showVehical)
        document.body.classList.toggle('overflow_vehicle');
        // localStorage.removeItem('vehical_details');
        // setTimeout(() => {
        //     navigate(`/`);
        //     window.location.reload();
        // }, 1000);
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>Are you sure?</h1>
                        <p>You want to delete this?</p>
                        <button onClick={onClose}>No</button>
                        <button
                            onClick={() => {
                                handleResetButton();
                                onClose();
                            }}
                        >
                            Yes, Delete it!
                        </button>
                    </div>
                );
            }
        });

    }

    const handleResetInputs = () => {
        setShowVehical(!showVehical)
        document.body.classList.toggle('overflow_vehicle');
        localStorage.removeItem('setSelectedFitmentType');
        localStorage.removeItem('vehical_details');
        localStorage.removeItem('setDiameterArray');
        localStorage.removeItem('setWidthArray');
        localStorage.removeItem('setPatternArray');
        localStorage.removeItem('setBradArray');
        localStorage.removeItem('setBradNameArray');
        localStorage.removeItem('setWheelOffsetArray');
        localStorage.removeItem('setModelArray');
        localStorage.removeItem('setMaxPrice');
        localStorage.removeItem('setMinPrice');
        localStorage.removeItem('setFirstValue');
        localStorage.removeItem('setSecondValue');
        localStorage.removeItem('setColourWheel');
        localStorage.removeItem('setStockWheel');
        localStorage.removeItem('setcategoryArray');
        localStorage.removeItem('setcategoryNameArray');
        localStorage.removeItem('setSpeedLoadRange');
        localStorage.removeItem('setSpeedRatingArray');
        localStorage.removeItem('setratioArray');
        localStorage.removeItem('setPlyArray');
        localStorage.removeItem('setSideWallArray');
        localStorage.removeItem('setMilageRatingArray');
        localStorage.removeItem('setRunFlat');
        localStorage.removeItem('setstuddable');
        localStorage.removeItem('settiresizes');
        localStorage.removeItem('inProductPage');
        localStorage.removeItem('setIsChecked');
        localStorage.removeItem('setIsCheckedStock');
        localStorage.removeItem('setSortingValue');
        localStorage.removeItem('setoffsetCurrentPage');
        localStorage.removeItem('setCurrentPage');


        localStorage.removeItem('setWheelSelectedFitmentType');
        localStorage.removeItem('WheelselectedCategories');
        localStorage.removeItem('WheelselectedCategoriesName');
        localStorage.removeItem('WheelselectedBrands');
        localStorage.removeItem('WheelselectedBrandsName');
        localStorage.removeItem('setWheelWheelOffsetArray');
        localStorage.removeItem('setWheelColourWheel');
        localStorage.removeItem('setWheelStockWheel');
        localStorage.removeItem('setWheelDiameterArray');
        localStorage.removeItem('setWheelWidthArray');
        localStorage.removeItem('setWheelPatternArray');
        localStorage.removeItem('setWheelBradArray');
        localStorage.removeItem('setWheelBradNameArray');
        localStorage.removeItem('setWheelcategoryArray');
        localStorage.removeItem('setWheelcategoryNameArray');
        localStorage.removeItem('setWheelModelArray');
        localStorage.removeItem('setWheelMaxPrice');
        localStorage.removeItem('setWheelMinPrice');
        localStorage.removeItem('setWheelFirstValue');
        localStorage.removeItem('setWheelSecondValue');
        localStorage.removeItem('setWheelIsChecked');
        localStorage.removeItem('setWheelIsCheckedStock');
        localStorage.removeItem('setWheelSortingValue');
        localStorage.removeItem('setWheeloffsetCurrentPage');
        localStorage.removeItem('setWheelCurrentPage');



        localStorage.removeItem('setWheelsSelectedFitmentType');
        localStorage.removeItem('setWheelsWheelOffsetArray');
        localStorage.removeItem('setWheelsColourWheel');
        localStorage.removeItem('setWheelsStockWheel');
        localStorage.removeItem('setWheelsDiameterArray');
        localStorage.removeItem('setWheelsWidthArray');
        localStorage.removeItem('setWheelsPatternArray');
        localStorage.removeItem('setWheelsBradArray');
        localStorage.removeItem('setWheelsBradNameArray');
        localStorage.removeItem('setWheelscategoryArray');
        localStorage.removeItem('setWheelscategoryNameArray');
        localStorage.removeItem('setWheelsModelArray');
        localStorage.removeItem('setWheelsMaxPrice');
        localStorage.removeItem('setWheelsMinPrice');
        localStorage.removeItem('setWheelsFirstValue');
        localStorage.removeItem('setWheelsSecondValue');
        localStorage.removeItem('setWheelsIsChecked');
        localStorage.removeItem('setWheelsIsCheckedStock');
        localStorage.removeItem('setWheelsSortingValue');
        localStorage.removeItem('setWheelsoffsetCurrentPage');
        localStorage.removeItem('setWheelsCurrentPage');



        localStorage.removeItem('setSwheelsSelectedFitmentType');
        localStorage.removeItem('setSwheelsWheelOffsetArray');
        localStorage.removeItem('setSwheelsColourWheel');
        localStorage.removeItem('setSwheelsStockWheel');
        localStorage.removeItem('setSwheelsDiameterArray');
        localStorage.removeItem('setSwheelsWidthArray');
        localStorage.removeItem('setSwheelsPatternArray');
        localStorage.removeItem('setSwheelsBradArray');
        localStorage.removeItem('setSwheelsBradNameArray');
        localStorage.removeItem('setSwheelscategoryArray');
        localStorage.removeItem('setSwheelscategoryNameArray');
        localStorage.removeItem('setSwheelsModelArray');
        localStorage.removeItem('setSwheelsMaxPrice');
        localStorage.removeItem('setSwheelsMinPrice');
        localStorage.removeItem('setSwheelsFirstValue');
        localStorage.removeItem('setSwheelsSecondValue');
        localStorage.removeItem('setSwheelsIsChecked');
        localStorage.removeItem('setSwheelsIsCheckedStock');
        localStorage.removeItem('setSwheelsSortingValue');
        localStorage.removeItem('setSwheelsoffsetCurrentPage');
        localStorage.removeItem('setSwheelsCurrentPage');
        setTimeout(() => {
            navigate(`/`);
            window.location.reload();
        }, 1000);

    }

    const handleResetButton = () => {
        localStorage.removeItem('setSelectedFitmentType');
        localStorage.removeItem('vehical_details');
        localStorage.removeItem('setDiameterArray');
        localStorage.removeItem('setWidthArray');
        localStorage.removeItem('setPatternArray');
        localStorage.removeItem('setBradArray');
        localStorage.removeItem('setBradNameArray');
        localStorage.removeItem('setWheelOffsetArray');
        localStorage.removeItem('setModelArray');
        localStorage.removeItem('setMaxPrice');
        localStorage.removeItem('setMinPrice');
        localStorage.removeItem('setFirstValue');
        localStorage.removeItem('setSecondValue');
        localStorage.removeItem('setColourWheel');
        localStorage.removeItem('setStockWheel');
        localStorage.removeItem('setcategoryArray');
        localStorage.removeItem('setcategoryNameArray');
        localStorage.removeItem('setSpeedLoadRange');
        localStorage.removeItem('setSpeedRatingArray');
        localStorage.removeItem('setratioArray');
        localStorage.removeItem('setPlyArray');
        localStorage.removeItem('setSideWallArray');
        localStorage.removeItem('setMilageRatingArray');
        localStorage.removeItem('setRunFlat');
        localStorage.removeItem('setstuddable');
        localStorage.removeItem('settiresizes');
        localStorage.removeItem('setIsChecked');
        localStorage.removeItem('setIsCheckedStock');
        localStorage.removeItem('setSortingValue');
        localStorage.removeItem('setoffsetCurrentPage');
        localStorage.removeItem('setCurrentPage');
        localStorage.removeItem('inProductPage');


        localStorage.removeItem('setWheelSelectedFitmentType');
        localStorage.removeItem('setWheelWheelOffsetArray');
        localStorage.removeItem('setWheelColourWheel');
        localStorage.removeItem('setWheelStockWheel');
        localStorage.removeItem('setWheelDiameterArray');
        localStorage.removeItem('setWheelWidthArray');
        localStorage.removeItem('setWheelPatternArray');
        localStorage.removeItem('setWheelBradArray');
        localStorage.removeItem('setWheelBradNameArray');
        localStorage.removeItem('setWheelcategoryArray');
        localStorage.removeItem('setWheelcategoryNameArray');
        localStorage.removeItem('setWheelModelArray');
        localStorage.removeItem('setWheelMaxPrice');
        localStorage.removeItem('setWheelMinPrice');
        localStorage.removeItem('setWheelFirstValue');
        localStorage.removeItem('setWheelSecondValue');
        localStorage.removeItem('setWheelIsChecked');
        localStorage.removeItem('setWheelIsCheckedStock');
        localStorage.removeItem('setWheelSortingValue');
        localStorage.removeItem('setWheeloffsetCurrentPage');
        localStorage.removeItem('setWheelCurrentPage');






        localStorage.removeItem('setWheelsSelectedFitmentType');
        localStorage.removeItem('setWheelsWheelOffsetArray');
        localStorage.removeItem('setWheelsColourWheel');
        localStorage.removeItem('setWheelsStockWheel');
        localStorage.removeItem('setWheelsDiameterArray');
        localStorage.removeItem('setWheelsWidthArray');
        localStorage.removeItem('setWheelsPatternArray');
        localStorage.removeItem('setWheelsBradArray');
        localStorage.removeItem('setWheelsBradNameArray');
        localStorage.removeItem('setWheelscategoryArray');
        localStorage.removeItem('setWheelscategoryNameArray');
        localStorage.removeItem('setWheelsModelArray');
        localStorage.removeItem('setWheelsMaxPrice');
        localStorage.removeItem('setWheelsMinPrice');
        localStorage.removeItem('setWheelsFirstValue');
        localStorage.removeItem('setWheelsSecondValue');
        localStorage.removeItem('setWheelsIsChecked');
        localStorage.removeItem('setWheelsIsCheckedStock');
        localStorage.removeItem('setWheelsSortingValue');
        localStorage.removeItem('setWheelsoffsetCurrentPage');
        localStorage.removeItem('setWheelsCurrentPage');



        localStorage.removeItem('setSwheelsSelectedFitmentType');
        localStorage.removeItem('setSwheelsWheelOffsetArray');
        localStorage.removeItem('setSwheelsColourWheel');
        localStorage.removeItem('setSwheelsStockWheel');
        localStorage.removeItem('setSwheelsDiameterArray');
        localStorage.removeItem('setSwheelsWidthArray');
        localStorage.removeItem('setSwheelsPatternArray');
        localStorage.removeItem('setSwheelsBradArray');
        localStorage.removeItem('setSwheelsBradNameArray');
        localStorage.removeItem('setSwheelscategoryArray');
        localStorage.removeItem('setSwheelscategoryNameArray');
        localStorage.removeItem('setSwheelsModelArray');
        localStorage.removeItem('setSwheelsMaxPrice');
        localStorage.removeItem('setSwheelsMinPrice');
        localStorage.removeItem('setSwheelsFirstValue');
        localStorage.removeItem('setSwheelsSecondValue');
        localStorage.removeItem('setSwheelsIsChecked');
        localStorage.removeItem('setSwheelsIsCheckedStock');
        localStorage.removeItem('setSwheelsSortingValue');
        localStorage.removeItem('setSwheelsoffsetCurrentPage');
        localStorage.removeItem('setSwheelsCurrentPage');


        setTimeout(() => {
            navigate(`/`);
            window.location.reload();
        }, 1000);
    }

    const showMenue = () => {
        setValueMenuSideBar('active-menu')
        document.body.classList.add('home-layout');

    }

    const showSearchBar = () => {
        setShowSeachbar('search-active')
        document.body.classList.toggle('home-layout');


    }

    const hideSearchBar = () => {
        setShowSeachbar('')
        document.body.classList.remove('home-layout');
    }

    const showAddVehicle = () => {
        setShowVehical(!showVehical)
        document.body.classList.toggle('overflow_vehicle');

    }


    const isOptionSelected = (option) => {
        if (!selectedVariant) {
            return false;
        }

        return (
            selectedVariant === option.value &&
            selectedVariantName.toLowerCase() === option.label.toLowerCase()
        );
    };

    const showCartPage = () => {
        navigate(`/add-cart`);
    }


    const handleDropdownClick = (param, concept) => {
        setSearchParam(param);
        setSearchConcept(concept);
        setDropdownOpen(false); // Close the dropdown after selecting an item
        inputReference.current.value = searchInputs;
        inputReference.current.param = param;
        inputReference.current.changeConcept = true;

        // Call the event handler function directly to simulate the onchange event
        searchFunction({ target: inputReference.current });
    };



    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen); // Toggle the dropdown state
    };

    const showSideSearchSection = () => {
        document.body.classList.add('open_search');
        setSideActive('active')
        inputReference.current.focus();
    }


    const hideSideSearch = () => {
        document.body.classList.remove('open_search');
        setSideActive('')
    }



    const navigateToNewPage = (itemid, description, name, category, brand, partNumber) => {
        let item_name_new = ""
        const item_name = description ? description : name;
        const item_id = itemid;
        const part_number = partNumber;

        if (item_name) {
            item_name_new = item_name.replace(/\s+|[\\/]/g, "-").toLowerCase();

        }

        if (category == 'Wheels' || category == 'WHEELS') {

            setTimeout(() => {
                navigate(`/wheels-product-details/${item_id}`);
                document.body.classList.remove('open_search');
                setSideActive('')
                window.location.reload(); // Perform a full page refresh
            }, 1000); // Delay of 2000 milliseconds (2 seconds)

        }
        else if (category == 'CustomeProduct') {
            let state = {
                item_id: item_id,
            }
            setTimeout(() => {
                navigate(`/custom-product-details/${item_id}?${item_name_new}`, { state: state });
                document.body.classList.remove('open_search');
                setSideActive('')
                window.location.reload(); // Perform a full page refresh
            }, 1000); // Delay of 2000 milliseconds (2 seconds)
        }

        else if (category == 'tires_wp') {
            const str = item_id;
            // const numberBeforeUnderscore = parseInt(str.split('_')[0]);
            // let state = {
            //     item_id: numberBeforeUnderscore,
            // }
            // setTimeout(() => {
            //     navigate(`/tires-details/${numberBeforeUnderscore}?`, { state: state });
            //     document.body.classList.remove('open_search');
            //     setSideActive('')
            //     window.location.reload();
            // }, 1000); 

            const itemId = str.split('_')[0];
            let state = {
                item_id: itemId,
            };

            setTimeout(() => {
                navigate(`/tires-details/${itemId}`, { state });
                document.body.classList.remove('open_search');
                setSideActive('');
                window.location.reload();
            }, 1000);
        }

        // For rough-country-product-details
        else if (brand == 'Ironman' || brand == 'Nitto' || brand == 'Rough Country' || brand == 'Torque' || brand == 'Venom Power') {
            setTimeout(() => {
                navigate(`/rough-country-product-details/${part_number}`);
                document.body.classList.remove('open_search');
                setSideActive('');
                window.location.reload(); // Perform a full page refresh
            }, 1000); // Delay of 1000 milliseconds (1 second)
        }

        else {
            setTimeout(() => {
                navigate(`/product-details/${item_id}?${item_name_new}`);
                document.body.classList.remove('open_search');
                setSideActive('')
                window.location.reload(); // Perform a full page refresh
            }, 1000); // Delay of 2000 milliseconds (2 seconds)
        }

    }
    // Debounce function
    function debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }
    // Usage in your search component
    const searchFunction = (event) => {
        const searchText = event.target.value;
        const searchCat = event.target?.param;
        const changeConcept = event.target?.changeConcept;
        const stock = event.target?.stock;
        const stockCheck = event.target?.stockCheck;
        var searchUpdate = false;
        var searchCatUpdate = false;
        // console.log("currentPage00000",currentPage)
        setIsloading(true);
        setSearchInput(searchText);
        if (searchText.length !== searchLength) {

            searchUpdate = false;
        } else {
            searchUpdate = true;
        }

        if (changeConcept) {
            searchCatUpdate = true
        }
        setSearchLength(searchText.length)
        setIsEmptyInput(searchText.trim() === '');
        if (searchText.length > 2) {
            setShowResult(true);
            fetchSearchData(searchText, searchCat, searchUpdate, searchCatUpdate, stock, stockCheck);
        } else {
            setSearchedData(0);
            setShowResult(false);
            setIsloading(false);
            setIsloadingSearch(false)
        }
    }
    const listInnerRef = useRef();

    const onScroll = () => {
        //     console.log('scroll called')


        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

            //  console.log("scrollTop",scrollTop,"scrollHeight",scrollHeight,"clientHeight",clientHeight);
            if (inStock) {
                if (currentPageInStock == 1 && currentPageAllItems == 1) {
                    // Ensure it's not the initial render
                    //     console.log("currentPageInStock+++fdsffsdf",currentPageInStock)
                    setCurrentPageInStock(2)
                    setCurrentPageAllItems(1)
                }
            } else {
                if (currentPageInStock == 1 && currentPageAllItems == 1) {
                    // Ensure it's not the initial render
                    //  console.log("currentPageInStock+++fdsffsdf",currentPageInStock)
                    setCurrentPageInStock(1)
                    setCurrentPageAllItems(2)
                }

            }

            if ((Math.ceil(scrollTop)) + clientHeight >= scrollHeight) {

                //  console.log("scrollTop+++++",scrollTop,"scrollHeight++++",scrollHeight,"clientHeight+++++",clientHeight,"currentPage",currentPage);
                if (inStock) {
                    setCurrentPageInStock((prevPage) => prevPage + 1);
                    setCurrentPageAllItems(1)
                    // console.log("inStoc+++++k",inStock)
                } else {
                    setCurrentPageAllItems((prevPage) => prevPage + 1);
                    // console.log("out of allitemsStoc+++++k",inStock)
                    setCurrentPageInStock(1)
                }
                // setCurrentPage((prevPage) => {
                //     const newPage = prevPage + 1;

                //     console.log(`New Page: ${newPage}`, currentPage);
                //     return newPage; // Don't forget to return the new value
                // });

                inputReference.current.value = searchInputs;
                inputReference.current.param = searchParam;
                inputReference.current.stockCheck = false;
                searchFunction({ target: inputReference.current });
            } else {
                // console.log("currentPageInStock=======453534fdffgdgh",currentPageInStock)
                // console.log("currentPageAllItems=======121435345dhfghfgh13123",currentPageAllItems)

            }
        }
    };



    const emptylocalstorage = () => {
        // localStorage.clear();
        localStorage.removeItem('setSelectedFitmentType');
        localStorage.removeItem('selectedCategories');
        localStorage.removeItem('selectedCategoriesName');
        localStorage.removeItem('selectedBrands');
        localStorage.removeItem('selectedBrandsName');
        localStorage.removeItem('setDiameterArray');
        localStorage.removeItem('setWidthArray');
        localStorage.removeItem('setPatternArray');
        localStorage.removeItem('setBradArray');
        localStorage.removeItem('setBradNameArray');
        localStorage.removeItem('setcategoryArray');
        localStorage.removeItem('setcategoryNameArray');
        localStorage.removeItem('setModelArray');
        localStorage.removeItem('setMaxPrice');
        localStorage.removeItem('setMinPrice');
        localStorage.removeItem('setFirstValue');
        localStorage.removeItem('setSecondValue');
        localStorage.removeItem('setSpeedLoadRange');
        localStorage.removeItem('setSpeedRatingArray');
        localStorage.removeItem('setratioArray');
        localStorage.removeItem('setPlyArray');
        localStorage.removeItem('setSideWallArray');
        localStorage.removeItem('setMilageRatingArray');
        localStorage.removeItem('setRunFlat');
        localStorage.removeItem('setstuddable');
        localStorage.removeItem('settiresizes');
        localStorage.removeItem('setIsChecked');
        localStorage.removeItem('setIsCheckedStock');
        localStorage.removeItem('setSortingValue');
        localStorage.removeItem('setoffsetCurrentPage');
        localStorage.removeItem('setCurrentPage');
        localStorage.removeItem('inProductPage');
    }


    const liststockCheck = useRef();
    const stockCheck = () => {
        inputReference.current.stockCheck = true;
        if (liststockCheck.current.checked) {
            inputReference.current.value = searchInputs;
            inputReference.current.stock = true;
            setInStock(false);
            searchFunction({ target: inputReference.current });
        } else {
            inputReference.current.value = searchInputs;
            inputReference.current.stock = false;
            searchFunction({ target: inputReference.current });
            setInStock(true);

        }
    }

    const openLoginModel = () => {
        setShowLoginModel(true);
        setShowClass(!showClass)

    }

    const openRegisterModel = () => {
        setShowRegisterModel(true);
        setShowClass(!showClass)


    }
    // Debounce the searchFunction with a 600ms delay
    const debouncedSearch = debounce(searchFunction, 600);



    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [errors, setNewErrors] = useState({});
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) {
            return; // Prevent multiple submissions while one is already in progress
        }

        setIsSubmitting(true);

        // Validation
        const newErrors = {};
        if (!formData.email) { newErrors.email = 'Email is required.'; setIsSubmitting(false); }
        if (!formData.password) { newErrors.password = 'Password is required.'; setIsSubmitting(false); }
        setNewErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            try {
                // Send sign-in data to server
                const response = await axios.post(`${mainUrl}/api/signin`, formData);
                if (response.data.success) {
                    setLoginUrlCustomer(response.data.loginUrl)
                    toast.success(response.data.message);
                    setShowLoginModel(false)
                    setLoggedIn(true);
                    localStorage.setItem('user_email', JSON.stringify(formData.email));
                    if (response.data.data && response.data.data.token) {
                        let token = response.data.data.token;
                        let cartItems = response.data.data.cartItems;
                        localStorage.setItem("user-token", token);
                        localStorage.setItem("cart-key", cartItems.cart_key);
                    }
                    setIsSubmitting(false); // Enable the button again
                } else {
                    toast.info(response.data.message);
                    setIsSubmitting(false); // Enable the button again
                }
            } catch (error) {
                console.error('Sign-in failed:', error);
                if (error.response && error.response.status === 401) {
                    toast.error(error.response.data.message || 'Unauthorized');
                } else if (error.response && error.response.data.message) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error('An unexpected error occurred.');
                }
                setIsSubmitting(false); // Enable the button again
            }
        }
    };
    const [newErrors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    const [formDataRegister, setFormDataRegister] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        username: '',
    });

    const handleChangeRegister = (e) => {
        setFormDataRegister({
            ...formDataRegister,
            [e.target.name]: e.target.value,
        });
    };

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/;
        return passwordRegex.test(password);
    };

    const handleSubmitRegister = async (e) => {
        e.preventDefault();
        if (isSubmitting) {
            return; // Prevent multiple submissions while one is already in progress
        }

        setIsSubmitting(true);

        // Validation
        const newErrors = {};
        if (!formDataRegister.firstName) newErrors.firstName = 'First name is required.';
        if (!formDataRegister.lastName) newErrors.lastName = 'Last name is required.';
        if (!formDataRegister.username) newErrors.username = 'User name is required.';
        if (!formDataRegister.email) newErrors.email = 'Email is required.';
        if (!formDataRegister.password) newErrors.password = 'Password is required.';
        if (!validatePassword(formDataRegister.password)) {
            newErrors.password = 'Password must be at least 8 characters long and contain atleast an uppercase letter, a lowercase letter, a number, and a special character.';
            setIsSubmitting(false);
        }
        if (formDataRegister.password !== formDataRegister.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match.';
            setIsSubmitting(false); // Set isSubmitting to false here
        }

        setErrors(newErrors);


        if (Object.keys(newErrors).length === 0) {
            localStorage.removeItem("cart-key");
            try {
                // Send registration data to server
                const response = await axios.post(`${mainUrl}/api/register`, formDataRegister);
                if (response.data.success) {
                    localStorage.setItem('user_email', JSON.stringify(formDataRegister.email));
                    if (response.data.data && response.data.data.token) {
                        let token = response.data.data.token;
                        let cartItems = response.data.data.cartItems;
                        localStorage.setItem("user-token", token);
                        localStorage.setItem("cart-key", cartItems.cart_key);
                    }
                    setShowRegisterModel(false);
                    setLoginUrlCustomer(response.data.loginUrl);
                    setLoggedIn(true);
                    setIsSubmitting(false); // Enable the button again
                }

                setSuccessMessage(response.data.message);
                toast.success(response.data.message);
                setIsSubmitting(false); // Enable the button again
            } catch (error) {
                console.error('Registration failed:', error);
                if (error.response && error.response.status === 401) {
                    toast.error(error.response.data.message || 'Unauthorized');
                } else if (error.response && error.response.data.message) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error('An unexpected error occurred.');
                }
                setIsSubmitting(false); // Enable the button again
            }
        }
    };

    const redirectToBigCommerce = async () => {

        let formDataRegisterNew = {};

        formDataRegisterNew.email = userEmail;
        formDataRegisterNew.password = "Seovikas@123";
        try {
            // Send registration data to server
            const response = await axios.post(`${mainUrl}/api/sso-login`, formDataRegisterNew);
            if (response.data.success) {
                setShowClass(!showClass)
                // window.open(response.data.loginUrl, '_blank');
                window.location = response.data.loginUrl

            }
        } catch (error) {
            console.error('Registration failed:', error);
        }
    }

    const redirectToWooCommerce = () => {
        window.location.href = "https://extremeperformance.com/wordpress/my-account/";
    };


    const redirectToProfile = async () => {
        setShowClass(!showClass)
    }

    // const deleteCartApi = async () => {
    //     const config = {
    //         method: 'get',
    //         maxBodyLength: Infinity,
    //         url: `${mainUrl}/api/clear`,
    //         withCredentials: true
    //     };

    //     try {
    //         await axios.request(config);
    //         localStorage.removeItem("totalCartItems");
    //         localStorage.removeItem("user-token");
    //         localStorage.removeItem("cart-key");
    //         console.log("Cart cleared successfully.");
    //     } catch (error) {
    //         console.error("Error clearing cart data:", error.response?.data || error.message);
    //         throw error;
    //     }
    // };

    // const clearWooCommerceCartApi = async () => {
    //     const cartKey = localStorage.getItem("cart-key") || "";
    //     const userToken = localStorage.getItem("user-token") || "";

    //     if (!cartKey) {
    //         console.error("Cart key is missing.");
    //         return;
    //     }

    //     try {
    //         const response = await axios.get(`${mainUrl}/api/clear-cart?cart_key=${cartKey}&user_token=${userToken}`);
    //         if (response.data && response.data.cartItems) {
    //             const { cartItems } = response.data;
    //             if (cartItems.items.length === 0) {
    //                 await deleteCartApi();
    //             }
    //         } else {
    //             console.warn("Unexpected response format from clear cart API:", response.data);
    //         }
    //     } catch (error) {
    //         console.error("Error clearing WooCommerce cart data:", error.response?.data || error.message);
    //         throw error;
    //     }
    // };

    async function logoutCustomerByUsername(userToken = '') {
        try {
            const response = await fetch(`${wc_url}/wp-json/custom/v1/logout-customer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ auth_token: userToken }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to log out customer');
            }

            const data = await response.json();
            console.log(data.message); // "Customer logged out successfully"
            return data.message;
        } catch (error) {
            console.error('Logout request failed:', error);
            throw error; // Rethrow for handling in redirectToLogout
        }
    }

    const getAttributionPayload = () => {
        const attributionCookie = getCookie('attribution_data');

        if (!attributionCookie) {
            return {
                gclid: "",
                utm_source: "",
                utm_medium: "",
                utm_campaign: ""
            };
        }

        try {
            const attributionData = JSON.parse(attributionCookie);

            return {
                gclid: attributionData.gclid || "",
                utm_source: attributionData.utm_source || "",
                utm_medium: attributionData.utm_medium || "",
                utm_campaign: attributionData.utm_campaign || ""
            };
        } catch (error) {
            return {
                gclid: "",
                utm_source: "",
                utm_medium: "",
                utm_campaign: ""
            };
        }
    };

    const appendAttributionParams = (checkoutUrl) => {
        const attributionPayload = getAttributionPayload();
        let checkoutUrlWithAttribution = checkoutUrl;

        Object.keys(attributionPayload).forEach((key) => {
            if (attributionPayload[key]) {
                checkoutUrlWithAttribution += `&${key}=${encodeURIComponent(attributionPayload[key])}`;
            }
        });

        return checkoutUrlWithAttribution;
    };

    const redirectToLogout = async () => {
        const userToken = localStorage.getItem("user-token") || "";
        const carKey = localStorage.getItem("cart-key") || "";

        try {
            const message = await logoutCustomerByUsername(userToken);

            // await clearWooCommerceCartApi();
            localStorage.removeItem("user_email");
            toast.info("You have been successfully logged out!");

            setLoggedIn(false);
            setShowClass(!showClass);
            localStorage.removeItem("user-token");
            localStorage.removeItem("cart-key");

            // setTimeout(() => {
            //     window.location = `${wc_url}/checkout?cocart-load-cart=key_${carKey}&logout=${userToken}`;
            //     // window.location.reload();
            // }, 200);

            setTimeout(() => {
                const checkoutUrl = `${wc_url}/checkout?cocart-load-cart=key_${carKey}&logout=${userToken}`;
                //new added
                window.location = appendAttributionParams(checkoutUrl);
            }, 200);

        } catch (error) {
            console.error("Error during logout:", error.response?.data || error.message);

            const errorMessage = error.response?.data?.message || error?.message || 'An unexpected error occurred.';
            const statusCode = error.response?.status || error.data?.status;

            if (statusCode === 401) {
                toast.error(errorMessage || 'Unauthorized');
            } else {
                toast.error(errorMessage);
            }
        }
    };

    // const redirectToLogout = async () => {
    //     localStorage.removeItem('user_email');
    //     toast.info("You have been successfully logout!");

    //     setLoggedIn(false);
    //     setShowClass(!showClass)
    //     window.location.reload();

    //     // setTimeout(function() {
    //     //     window.location.reload();
    //     //   }, 500); 


    // }


    const redirectToWheelPage = () => {
        document.body.classList.remove('open_search');
        setTimeout(() => {
            navigate(`/wheels`);
            setLoader(false);

        }, 1000);

    }

    const redirectToTirePage = () => {
        document.body.classList.remove('open_search');
        setTimeout(() => {
            navigate(`/tires`);
            setLoader(false);

        }, 1000);

    }

    const handleShowCat = (id, cat) => {
        document.body.classList.remove('open_search');
        // setShow(true);
        // Perform desired action with the id
        setTimeout(() => {
            // navigate(`/categories-home?id=${id}&cat=${cat}`);
            navigate(`/categories-home/${id}/${cat}`);
        }, 1000);
    };

    const handleShowCatNew = (id) => {
        document.body.classList.remove('open_search');
        // if (id == 1) {
        //     setTimeout(() => {
        //         navigate(`/products/11`);
        //     }, 1000);
        // } else if (id == 2) {
        //     setTimeout(() => {
        //         navigate(`/products/21`);
        //     }, 1000);
        // } else {
        //     setTimeout(() => {
        //         navigate(`/products/2`);
        //     }, 1000);
        // }
    }
    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        setCurrentPageInStock(1);
        setCurrentPageAllItems(1);
        // console.log('current page set to default', currentPage);
        // Check if the input value is empty or only contains whitespace
        if (inputValue.trim() === '') {
            setCurrentPageInStock(1);
            setCurrentPageAllItems(1);
        }
    };

    const handleKeyDown = (e) => {
        // Check if the Backspace key (key code 8) is pressed
        if (e.keyCode === 8) {
            setCurrentPageInStock(1);
            setCurrentPageAllItems(1);
            // console.log('current page set to default', currentPage);

        }
    };

    const highlightSearchTerm = (item, searchTerm) => {
        //  console.log("item",item)
        //  console.log("searchTerm",searchTerm)
        const defaultDescription = '';

        // console.log("defaultDescription",defaultDescription)
        if (!searchTerm) {
            return {
                highlightedDescription: defaultDescription,

            };
        }


        const searchTermWords = searchTerm.split(/\s+/).filter(word => word.trim() !== '');
        const regex = new RegExp(searchTermWords.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'gi');
        const itemWords = item.split(' ');
        const highlightedDescription = itemWords.map(word => {
            return word.replace(regex, match => `<span style="background-color: yellow; font-weight: bold; color: blue;">${match}</span>`);
        }).join(' ');

        //  console.log(highlightedDescription);


        return {
            highlightedDescription,

        };
    };

    // const highlightSearchTerm = (item, searchTerm) => {


    //     const regex = new RegExp(searchTerm, 'gi');

    //     const highlightedDescription = item.replace(regex, match => `<span style="background-color: yellow; font-weight: bold; color: blue;">${match}</span>`);
    //     // const highlightedProductName = item ? item.product_name.replace(regex, match => `<span style="background-color: yellow; font-weight: bold; color: blue;">${match}</span>`) : '';
    //     // const highlightedPartNumber = item.part_number ? item.part_number.replace(regex, match => `<span style="background-color: yellow; font-weight: bold; color: blue;">${match}</span>`) : '';

    //     return {
    //         highlightedDescription,

    //     };
    // };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission
            // You can add any other logic here, like handling the Enter key press
        }
    };

    useEffect(() => {
        axios.get(`${mainUrl}/api/vehical-search`)
            .then(response => {
                const SearchOptions = response.data.data.map((item) => ({
                    value: item.id,
                    label: `${item.year} ${item.make_name} ${item.model_name} ${item.submodel_name || ''}`.trim(),
                    year: item.year,
                    make: item.make,
                    make_name: item.make_name,
                    model: item.model,
                    model_name: item.model_name,
                    variant: item.submodel,
                    variant_name: item.submodel_name,
                }));

                setVehicalSearchOptions(SearchOptions);
            })
            .catch(error => console.error(error));
    }, []);

    const handleShow = () => {
        document.body.classList.remove('overflow_vehicle');
        let state = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
            make_name: selectedMakeName,
            model_name: selectedModelName,
            variant_name: selectedVariantName,

        };
        localStorage.setItem('vehical_details', JSON.stringify(state));
        localStorage.removeItem('wheels_details');

        const response = axios.post(`${mainUrl}/api/save-vehical`, state)
            .then(response => {
                console.log('Data saved successfully');
            })
            .catch(error => {
                console.error('Error saving data:', error);
            });

        setTimeout(() => {
            navigate(`/`);
            window.location.reload();
        }, 1500);
    };


    const handleVehicalSearchChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedVehicalSearch(selectedOption.value);
            setSelectedVehicalSearchName(selectedOption.label);

            setSelectedYear(selectedOption.year);
            setSelectedMake(selectedOption.make);
            setSelectedModel(selectedOption.model);
            setSelectedVariant(selectedOption.variant);

            setSelectedMakeName(selectedOption.make_name);
            setSelectedModelName(selectedOption.model_name);
            setSelectedVariantName(selectedOption.variant_name);
        }
    };


    const cleanText = (text) => {
        if (!text) return '';
        return text
            .replace(/\bnull\b/gi, '')
            .replace(/\bundefined\b/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
    };


    return (
        <div>
            {/* <!-- header start --> */}
            <section className='position-relative'>
                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"

                />
                <Alert show={alertshow} variant="success" className='position-absolute alertForClear'>
                    <span></span>
                </Alert>
                <header className="main-header ">
                    <div className="container">
                        <div className="mian-header main-header-serachbar">
                            <div className="logo">
                                <div className="man-logo">
                                    <a href="/" onClick={emptylocalstorage}>
                                        <img className="" src={`${S3_IMAGES_local}images/extreme_logo.svg`} loading="lazy" alt="logo" height="100%" width="100%" />
                                    </a>
                                </div>
                            </div>

                            <div className='secrch-bar' >
                                <a href="#" title="Search here" className='searchIconOpen text-danger' onClick={showSideSearchSection}>
                                    <i className="fa fa-search" aria-hidden="true" title="Search here"></i><span style={{ display: 'none' }}>search-bar</span>
                                </a>

                                <form className="form-search" method="get" action="#">
                                    <div className='dropdown-category'>
                                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" onClick={toggleDropdown}>
                                            <span id="search_concept">{searchConcept}</span> <span className="caret"></span>
                                        </button>
                                        <ul className={`dropdown-menu scrollable-dropdown ${isDropdownOpen ? "show" : ""}`} role="menu">
                                            <li><a href="#" onClick={() => handleDropdownClick('0', 'All')}>All</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('1', 'Interior Accessories')}>Interior Accessories</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('2', 'Exterior Accessories')}>Exterior Accessories</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('3', 'Performance')}>Performance</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('7', 'Body Parts')}>Body Parts</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('5', 'Wheels & Tires')}>Wheels & Tires</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('4', 'Lighting')}>Lighting</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('6', 'Parts')}>Parts</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('8', 'Audio & Electronics')}>Audio & Electronics</a></li>
                                            <li><a href="#" onClick={() => handleDropdownClick('9', 'Automotive Tools')}>Automotive Tools</a></li>
                                        </ul>
                                    </div>

                                    <input
                                        type="search"
                                        name="search"
                                        className="main-search-input"
                                        placeholder="I am shopping for ..."
                                        onClick={showSideSearchSection}
                                        autoComplete="off"
                                        onInput={handleInputChange}
                                        onKeyDown={handleKeyDown}
                                    />

                                    <button type="submit">
                                        <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                fill="white" />
                                            <path
                                                d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                fill="white" />
                                            <path
                                                d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                fill="white" />
                                            <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                fill="white" />
                                            <path
                                                d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                fill="white" />
                                            <path
                                                d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                fill="white" />
                                            <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                fill="white" />
                                            <path
                                                d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                fill="white" />
                                            <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                fill="white" />
                                            <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                fill="white" />
                                            <path
                                                d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                fill="white" />
                                        </svg>
                                        <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%" />
                                        Search
                                    </button>
                                </form>

                                <div className={`search_opener ${sideActive}`} >
                                    <a href="#" className='searchIconClose' onClick={hideSideSearch}>
                                        <img src="/images/x-mark.svg" alt='cross' height="100%" width="100%" />
                                    </a>
                                    <div className={!isloading ? 'loader-line hide' : 'loader-line'}></div>
                                    <div className='search-closer' onClick={hideSideSearch}></div>
                                    <div className='search_box_main'>

                                        <div className='searc_heading'>
                                            <p>Searching for ?</p>
                                            <ul className="stockCheckboxUl">
                                                <li>
                                                    <input type="checkbox" className=" tgl tgl-light" id="stockCheck" name="stockCheck" ref={liststockCheck} onChange={stockCheck} value="2" />
                                                    <label htmlFor="stockCheck" className=" tgl-btn">
                                                    </label>
                                                </li>
                                                <li className="staggeredLi">
                                                    {
                                                        inStock ? <span>In Stock Items</span> : <span>All Items</span>
                                                    }

                                                </li>
                                            </ul>
                                        </div>
                                        <form className="form-search" >
                                            <div className='dropdown-category' onClick={toggleDropdown}>
                                                <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" >
                                                    <span id="search_concept">{searchConcept}</span> <span className="caret"></span>
                                                </button>
                                                <ul className={`dropdown-menu scrollable-dropdown ${isDropdownOpen ? "show" : ""}`} role="menu">
                                                    <li><a href="#" onClick={() => handleDropdownClick('0', 'All')}>All</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('1', 'Interior Accessories')}>Interior Accessories</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('2', 'Exterior Accessories')}>Exterior Accessories</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('3', 'Performance')}>Performance</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('7', 'Body Parts')}>Body Parts</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('5', 'Wheels & Tires')}>Wheels & Tires</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('4', 'Lighting')}>Lighting</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('6', 'Parts')}>Parts</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('8', 'Audio & Electronics')}>Audio & Electronics</a></li>
                                                    <li><a href="#" onClick={() => handleDropdownClick('9', 'Automotive Tools')}>Automotive Tools</a></li>
                                                </ul>
                                            </div>
                                            <input
                                                type="search"
                                                name="search"
                                                className="main-search-input"
                                                placeholder="I am shopping for ..."
                                                ref={inputReference}
                                                autoComplete="off"
                                                onChange={debouncedSearch}
                                                onInput={handleInputChange}
                                                onKeyDown={handleKeyDown}
                                                onKeyPress={handleKeyPress}

                                            />
                                            {/* {isloading ? <img className="wheel_gif_icon search_side_gif" src="/images/only_wheel_gif.gif" alt="gif_icon" height="100%" width="100%" /> : ""} */}
                                            <button type="">
                                                <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                        fill="white"></path>
                                                    <path
                                                        d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                        fill="white"></path>
                                                    <path
                                                        d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                        fill="white"></path>
                                                    <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                        fill="white"></path>
                                                    <path
                                                        d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                        fill="white"></path>
                                                    <path
                                                        d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                        fill="white"></path>
                                                    <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                        fill="white"></path>
                                                    <path
                                                        d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                        fill="white"></path>
                                                    <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                        fill="white"></path>
                                                    <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                        fill="white"></path>
                                                    <path
                                                        d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                        fill="white"></path>
                                                </svg>
                                                <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                Search
                                            </button>
                                        </form>
                                        {
                                            !isloadingSearch || searchLength < 3 || isEmptyInput ?
                                                <div className={`search_banners`}>
                                                    <div className='searc_heading second'>
                                                        <p>Are you looking for ?</p>
                                                    </div>
                                                    <div className='banner_box' onClick={redirectToWheelPage}>
                                                        <div className='banner_img'>
                                                            <img src='/images/wheels_darkpng.png' alt="img" height="100%" width="100%" />
                                                        </div>
                                                        <div className='banner_text'>
                                                            <h2>Wheels</h2>
                                                        </div>
                                                    </div>

                                                    <div className='banner_box' onClick={redirectToTirePage}>
                                                        <div className='banner_img'>
                                                            <img src='/images/tires_img.png' alt="img" height="100%" width="100%" />
                                                        </div>
                                                        <div className='banner_text'>
                                                            <h2>Tires</h2>
                                                        </div>
                                                    </div>

                                                    <div className='banner_box' onClick={() => handleShowCat(3, 'Performance')}>
                                                        <div className='banner_img'>
                                                            <img src='/images/turbo_perf.png' alt="img" height="100%" width="100%" />
                                                        </div>
                                                        <div className='banner_text'>
                                                            <h2>Performance</h2>
                                                        </div>
                                                    </div>

                                                    <a href="/products/11" className='text-decoration-none banner_box'>
                                                        <div className='banner_box_inside' onClick={() => handleShowCatNew(2)}>

                                                            <div className='banner_img'>
                                                                <img src='/images/lights_img.png' alt="img" height="100%" width="100%" />
                                                            </div>
                                                            <div className='banner_text'>
                                                                <h2>Lighting</h2>
                                                            </div>

                                                        </div>
                                                    </a>

                                                    <a href="/products/21" className='text-decoration-none banner_box'>
                                                        <div className='banner_box_inside' onClick={() => handleShowCatNew(2)}>

                                                            <div className='banner_img'>
                                                                <img src='/images/suspen_img.png' alt="img" height="100%" width="100%" />
                                                            </div>
                                                            <div className='banner_text'>
                                                                <h2>Suspension</h2>
                                                            </div>

                                                        </div>
                                                    </a>

                                                    <a href="/products/2" className='text-decoration-none banner_box'>
                                                        <div className='banner_box_inside' onClick={() => handleShowCatNew(3)}>

                                                            <div className='banner_img'>
                                                                <img src='/images/winches_hitches.png' alt="img" height="100%" width="100%" />
                                                            </div>
                                                            <div className='banner_text'>
                                                                <h2>Winches & Hitches</h2>
                                                            </div>

                                                        </div>
                                                    </a>

                                                </div>
                                                : ""

                                        }

                                        <p>{isloadingSearch && searchedData.length > 0 && searchLength > 0 ? "Showing " + searchedData.length + " result(s) from " + searchedDataCount : ""}</p>
                                        <div className='result-div' onScroll={onScroll} ref={listInnerRef}>
                                            {
                                                isloadingSearch && searchedData && searchLength > 0 ?
                                                    searchedData.length > 0 ?
                                                        searchedData.map((itm, index) => (
                                                            <div className='produc-list d-flex' key={itm.item_id} onClick={() => navigateToNewPage(itm.item_id, itm.part_description, itm.product_name, itm.category_name, itm.brand, itm.part_number)}>
                                                                <div className='image'>
                                                                    {/* {itm.category_name !== 'CustomeProduct' ? (
                                                                        itm.category_name !== 'Wheels' ? (
                                                                            <img
                                                                                src={itm.s3_images.length > 0 ? S3_IMAGES + itm.s3_images[0] : S3_IMAGES + itm.brand_logo}
                                                                                alt="img"
                                                                                height="100%"
                                                                                width="100%"
                                                                            />
                                                                        ) : (
                                                                            <img src={itm.image ? S3_IMAGES + itm.image.split(',')[0] : S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                        )
                                                                    ) : (
                                                                        itm.category_name === 'tires_wp' ? (
                                                                            <img src={itm.image} alt="img" height="100%" width="100%" />
                                                                        ) : (
                                                                            <img src={itm.image} alt="img" height="100%" width="100%" />
                                                                        )
                                                                    )} */}



                                                                    {/* {
                                                                        itm.category_name === 'CustomeProduct' ? (
                                                                            <img src={itm.image} alt="img" height="100%" width="100%" />
                                                                        ) : itm.category_name === 'Wheels' || itm.category_name === 'WHEELS' ? (

                                                                            <img src={itm.image && itm.image.startsWith('https://') ? itm.image : itm.image ? S3_IMAGES + itm.image.split(',')[0] : S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />

                                                                        ) : itm.category_name === 'tires_wp' ? (
                                                                            itm.image ? 
                                                                            <img src={itm.image} alt="img" height="100%" width="100%" />
                                                                            :
                                                                            <img src={S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                        ) : (
                                                                            <img
                                                                                src={itm.s3_images.length > 0 ? S3_IMAGES + itm.s3_images[0] : S3_IMAGES + itm.brand_logo}
                                                                                alt="img"
                                                                                height="100%"
                                                                                width="100%"
                                                                            />
                                                                        )
                                                                    } */}

                                                                    {
                                                                        (itm.brand === 'Ironman' || itm.brand === 'Nitto' || itm.brand === 'Rough Country' || itm.brand === 'Torque' || itm.brand === 'Venom Power') ? (
                                                                            <img
                                                                                src={itm.image ? itm.image : '/images/no-image-found.png'}
                                                                                alt={itm.product_name}
                                                                                height="100%"
                                                                                width="100%"
                                                                            />
                                                                        ) : itm.category_name === 'CustomeProduct' ? (
                                                                            <img src={itm.image} alt="img" height="100%" width="100%" />
                                                                        ) : itm.category_name === 'Wheels' || itm.category_name === 'WHEELS' ? (
                                                                            <img
                                                                                src={itm.image && itm.image.startsWith('https://') ? itm.image : itm.image ? S3_IMAGES + itm.image.split(',')[0] : S3_IMAGES + itm.brand_logo}
                                                                                alt="img"
                                                                                height="100%"
                                                                                width="100%"
                                                                            />
                                                                        ) : itm.category_name === 'tires_wp' ? (
                                                                            itm.image ?
                                                                                <img src={itm.image} alt="img" height="100%" width="100%" />
                                                                                :
                                                                                <img src={S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                        ) : (
                                                                            <img
                                                                                src={itm.s3_images.length > 0 ? S3_IMAGES + itm.s3_images[0] : S3_IMAGES + itm.brand_logo}
                                                                                alt="img"
                                                                                height="100%"
                                                                                width="100%"
                                                                            />
                                                                        )
                                                                    }



                                                                </div>
                                                                <div>
                                                                    <div className='text'>

                                                                        {/* <p >


                                                                            {itm.category_name == 'tires_wp' ? (
                                                                                <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(itm.product_name, searchInputs).highlightedDescription }}></span>
                                                                            ) : itm.category_name == 'Wheels' || itm.category_name == 'WHEELS' ? (
                                                                                <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm((itm.brand == "ESR" && itm.product_name == "ESR - -  0MM 5X105") ? itm.part_description : itm.product_name, searchInputs).highlightedDescription }}></span>
                                                                            ) : (
                                                                                <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(itm.part_description, searchInputs).highlightedDescription }}></span>
                                                                            )}
                                                                        </p> */}

                                                                        <p>
                                                                            {(
                                                                                itm.brand === 'Ironman' || itm.brand === 'Nitto' || itm.brand === 'Rough Country' || itm.brand === 'Torque' || itm.brand === 'Venom Power'
                                                                            ) ? (
                                                                                <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(itm.product_name, searchInputs).highlightedDescription }}></span>
                                                                            ) : itm.category_name === 'tires_wp' ? (
                                                                                <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(itm.product_name, searchInputs).highlightedDescription }}></span>
                                                                            ) : itm.category_name === 'Wheels' || itm.category_name === 'WHEELS' ? (
                                                                                <span dangerouslySetInnerHTML={{
                                                                                    __html: highlightSearchTerm(
                                                                                        cleanText(
                                                                                            (itm.brand === "ESR" && itm.product_name === "ESR - -  0MM 5X105") ? itm.part_description : itm.product_name,
                                                                                        ), searchInputs
                                                                                    ).highlightedDescription
                                                                                }}></span>
                                                                            ) : (
                                                                                <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(itm.part_description, searchInputs).highlightedDescription }}></span>
                                                                            )}
                                                                        </p>


                                                                        <div className="price-cart">
                                                                            <div className="price mt-2">
                                                                                <strong><span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(itm.part_number, searchInputs).highlightedDescription }}></span></strong>



                                                                            </div>
                                                                            {/* <div className="price" title='Stock'>
                                                                                {
                                                                                    itm.stock > 0 ?
                                                                                        <span><i className="fa fa-industry text-success" aria-hidden="true"></i> {itm.stock}</span>

                                                                                        :
                                                                                        <span><i className="fa fa-industry text-danger" aria-hidden="true"> </i> 0 </span>
                                                                                }

                                                                            </div> */}
                                                                            <div className="price" title="Stock">
                                                                                {
                                                                                    itm.brand === "Rough Country" &&
                                                                                        itm.availability?.toUpperCase().startsWith("ETA") || itm.availability?.toUpperCase().startsWith("PLEASE")
                                                                                        ?
                                                                                        <span>
                                                                                            <i className="fa fa-industry text-success" aria-hidden="true"></i> 1
                                                                                        </span>
                                                                                        :
                                                                                        itm.stock > 0
                                                                                            ?
                                                                                            <span>
                                                                                                <i className="fa fa-industry text-success" aria-hidden="true"></i> {itm.stock}
                                                                                            </span>
                                                                                            :
                                                                                            <span>
                                                                                                <i className="fa fa-industry text-danger" aria-hidden="true"></i> 0
                                                                                            </span>
                                                                                }
                                                                            </div>

                                                                        </div>



                                                                        <div className="price-cart">
                                                                            <div className="price">
                                                                                {
                                                                                    itm && itm.price ?
                                                                                        <h5 className="m-0">${parseFloat(itm.price).toFixed(2)}</h5>
                                                                                        :
                                                                                        <h5 className="m-0">N.A</h5>
                                                                                }
                                                                            </div>

                                                                            {/* <div className="cart-btn">
                                                                                <a href="#"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                >
                                                                                    {
                                                                                        itm.brand_logo ?
                                                                                            itm.category_name != 'Wheels' ?
                                                                                                <img src={S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                                                : <img src={S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                                            :
                                                                                            <img src="/images/no-image-found.png" alt="img" height="100%" width="100%" />
                                                                                    }
                                                                                </a>
                                                                            </div> */}

                                                                            {/* <div className="cart-btn">
                                                                                <a href="#" style={{ cursor: 'pointer' }}>
                                                                                    {
                                                                                        itm.brand === 'Ironman' || itm.brand === 'Nitto' || itm.brand === 'Rough Country' || itm.brand === 'Torque' || itm.brand === 'Venom Power' ?
                                                                                            <img
                                                                                                src="https://media.roughcountry.com/media/catalog/product/r/c/rc-logo-stamp2.jpg"
                                                                                                alt="img"
                                                                                                height="100%"
                                                                                                width="100%"
                                                                                            />
                                                                                            : itm.brand_logo ?
                                                                                                itm.category_name !== 'Wheels' ?
                                                                                                    <img src={S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                                                    : <img src={S3_IMAGES + itm.brand_logo} alt="img" height="100%" width="100%" />
                                                                                                :
                                                                                                <img src="/images/no-image-found.png" alt="img" height="100%" width="100%" />
                                                                                    }
                                                                                </a>
                                                                            </div> */}

                                                                            <div className="cart-btn">
                                                                                <a href="#" style={{ cursor: 'pointer' }}>
                                                                                    {
                                                                                        itm.category_name !== "tires_wp" &&
                                                                                            (itm.brand === 'Ironman' ||
                                                                                                itm.brand === 'Nitto' ||
                                                                                                itm.brand === 'Rough Country' ||
                                                                                                itm.brand === 'Torque' ||
                                                                                                itm.brand === 'Venom Power') ? (
                                                                                            <img
                                                                                                src="https://media.roughcountry.com/media/catalog/product/r/c/rc-logo-stamp2.jpg"
                                                                                                alt="img"
                                                                                                height="100%"
                                                                                                width="100%"
                                                                                            />
                                                                                        ) : itm.brand_logo ? (
                                                                                            <img
                                                                                                // src={S3_IMAGES + itm.brand_logo}
                                                                                                src={itm.brand_logo.startsWith("https") ? itm.brand_logo : S3_IMAGES + itm.brand_logo}
                                                                                                alt="img"
                                                                                                height="100%"
                                                                                                width="100%"
                                                                                            />
                                                                                        ) : (
                                                                                            <img
                                                                                                src="/images/no-image-found.png"
                                                                                                alt="img"
                                                                                                height="100%"
                                                                                                width="100%"
                                                                                            />
                                                                                        )
                                                                                    }
                                                                                </a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <p>Sorry, we couldn't find any products matching your search criteria. Please search again!</p>
                                                    :
                                                    ""
                                            }
                                        </div>


                                    </div>
                                </div>
                            </div>


                            <div className={`add_vehicle_mobile ${showVehical ? 'show' : ""}`}>
                                <button onClick={showAddVehicle}><i className="fa fa-car" title="Select Car"></i></button>
                                {
                                    defaultyear ?
                                        <li className='list-unstyled'>
                                            <strong>{defaultyear}&nbsp;{defaultMakeName}&nbsp;{defaultModelName} </strong> &nbsp;
                                            <i className="fa fa-pencil text-danger" aria-hidden="true" onClick={onClickEdit} style={{ cursor: 'pointer', margin: '0px 6px' }} title='Edit Search'></i>
                                            <i className="fa fa-trash" aria-hidden="true" onClick={handleReset} style={{ cursor: 'pointer' }} title='Clear Search'></i>
                                            <i className="fa fa-times" aria-hidden="true" onClick={showAddVehicle}></i>
                                        </li>

                                        :
                                        <li className="list-unstyled">
                                            <strong onClick={onClickEdit}>Add Your Vehicle </strong> &nbsp;
                                            <i className="fa fa-plus text-danger" aria-hidden="true" title="Edit Search" onClick={onClickEdit}></i>
                                            <i className="fa fa-times" aria-hidden="true" onClick={showAddVehicle}></i>
                                        </li>
                                }

                            </div>

                            <div className="cart_on_mobile">
                                <a href="#" title="Cart" className="icon" onClick={showCartPage}>
                                    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.982759 2.25205H4.07847L5.65092 11.2691C5.7738 11.9078 6.48624 12.5712 7.10048 12.5712H17.6654C18.3288 12.5712 18.8201 11.9815 18.8938 11.392L21.3263 1.71157C21.3508 1.63787 21.3508 1.56418 21.3508 1.4658C21.3508 0.80238 20.8347 0.286509 20.1223 0.286509H7.91125C7.37073 0.286509 6.92856 0.728672 6.92856 1.2692C6.92856 1.80973 7.37073 2.25189 7.91125 2.25189H19.1887L18.8202 3.72615H8.59927C8.05874 3.72615 7.61658 4.16832 7.61658 4.70884C7.61658 5.24937 8.05874 5.69154 8.59927 5.69154H18.3042L17.9356 7.16593H9.1397C8.59917 7.16593 8.15701 7.60809 8.15701 8.14862C8.15701 8.68915 8.59917 9.13131 9.1397 9.13131H17.4442L17.0757 10.6056H7.54275L5.87211 1.09717C5.79842 0.630306 5.38077 0.286377 4.9139 0.286377H0.982693C0.442163 0.286377 0 0.72854 0 1.26907C0 1.8096 0.442163 2.25194 0.982693 2.25194L0.982759 2.25205Z" fill="#272727"></path><path d="M16.0444 18.7136C17.4449 18.7136 18.575 17.5589 18.575 16.1338C18.575 14.8071 17.6168 13.726 16.3639 13.5786H16.3393H16.2656H16.1428H8.59993H8.55074H8.45253C7.05198 13.5786 5.92188 14.7334 5.92188 16.1585C5.9217 17.5834 7.05198 18.7136 8.42783 18.7136C9.80368 18.7136 10.9585 17.5589 10.9585 16.1338C10.9585 15.9127 10.934 15.7161 10.8848 15.5195H13.612C13.5628 15.7161 13.5383 15.9127 13.5383 16.1338C13.5383 17.5588 14.6686 18.7136 16.0445 18.7136H16.0444ZM16.0444 15.5195C16.3391 15.5195 16.6094 15.7898 16.6094 16.1338C16.6094 16.4777 16.3636 16.748 16.0444 16.748C15.7249 16.748 15.4793 16.4777 15.4793 16.1338C15.4791 15.7898 15.7494 15.5195 16.0444 15.5195ZM8.42781 16.748C8.13303 16.748 7.86276 16.4777 7.86276 16.1338C7.86276 15.7898 8.10852 15.5195 8.42781 15.5195C8.74727 15.5195 8.99287 15.7898 8.99287 16.1338C8.99287 16.4777 8.74727 16.748 8.42781 16.748Z" fill="#272727"></path></svg>
                                    {
                                        totalCartItemsValue ?
                                            <span className='cartValue text-danger'>{totalCartItemsValue}</span> : ""
                                    }
                                </a>
                            </div>
                            {/* <div className="nav-item user-mobile" onClick={showAccountDetails}><i className="fa fa-user" aria-hidden="true"></i></div> */}
                            <div className="nav-item user-mobile" onClick={redirectToWooCommerce}><i className="fa fa-user" aria-hidden="true"></i></div>


                            <div className="burger-btn">
                                <button onClick={showMenue} title="menus toggle">
                                    <svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 0H28L27 4H4L5 0Z" fill="#272727" />
                                        <path d="M3 6H26L25 10H2L3 6Z" fill="#272727" />
                                        <path d="M1 12H24L23 16H0L1 12Z" fill="#272727" />
                                    </svg>
                                </button>
                            </div>
                            <div className="account-section">
                                <ul className="acoount-bar p-0">
                                    <li className="nav-item text-danger">
                                        {
                                            defaultyear ?
                                                <div>
                                                    <span className='list-unstyled'>
                                                        <strong>{defaultyear}&nbsp;{defaultMakeName}&nbsp;{defaultModelName} </strong> &nbsp;
                                                        <i className="fa fa-pencil text-danger" aria-hidden="true" onClick={onClickEdit} style={{ cursor: 'pointer', margin: '0px 6px' }} title='Edit Search'></i>
                                                        <i className="fa fa-trash" aria-hidden="true" onClick={handleReset} style={{ cursor: 'pointer' }} title='Clear Search'></i>
                                                    </span>

                                                </div>

                                                :
                                                <div>
                                                    <span className='list-unstyled' onClick={onClickEdit}>
                                                        <strong>Add Your Vehicle </strong> &nbsp;
                                                        <i className="fa fa-plus text-danger" aria-hidden="true" style={{ cursor: 'pointer' }} title='Edit Search'></i>

                                                    </span>

                                                </div>
                                        }
                                    </li>
                                    <li className="nav-item" onClick={showCartPage}>
                                        <svg width="22" height="19" viewBox="0 0 22 19" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.982759 2.25205H4.07847L5.65092 11.2691C5.7738 11.9078 6.48624 12.5712 7.10048 12.5712H17.6654C18.3288 12.5712 18.8201 11.9815 18.8938 11.392L21.3263 1.71157C21.3508 1.63787 21.3508 1.56418 21.3508 1.4658C21.3508 0.80238 20.8347 0.286509 20.1223 0.286509H7.91125C7.37073 0.286509 6.92856 0.728672 6.92856 1.2692C6.92856 1.80973 7.37073 2.25189 7.91125 2.25189H19.1887L18.8202 3.72615H8.59927C8.05874 3.72615 7.61658 4.16832 7.61658 4.70884C7.61658 5.24937 8.05874 5.69154 8.59927 5.69154H18.3042L17.9356 7.16593H9.1397C8.59917 7.16593 8.15701 7.60809 8.15701 8.14862C8.15701 8.68915 8.59917 9.13131 9.1397 9.13131H17.4442L17.0757 10.6056H7.54275L5.87211 1.09717C5.79842 0.630306 5.38077 0.286377 4.9139 0.286377H0.982693C0.442163 0.286377 0 0.72854 0 1.26907C0 1.8096 0.442163 2.25194 0.982693 2.25194L0.982759 2.25205Z"
                                                fill="#E81C2E" />
                                            <path
                                                d="M16.0444 18.7136C17.4449 18.7136 18.575 17.5589 18.575 16.1338C18.575 14.8071 17.6168 13.726 16.3639 13.5786H16.3393H16.2656H16.1428H8.59993H8.55074H8.45253C7.05198 13.5786 5.92188 14.7334 5.92188 16.1585C5.9217 17.5834 7.05198 18.7136 8.42783 18.7136C9.80368 18.7136 10.9585 17.5589 10.9585 16.1338C10.9585 15.9127 10.934 15.7161 10.8848 15.5195H13.612C13.5628 15.7161 13.5383 15.9127 13.5383 16.1338C13.5383 17.5588 14.6686 18.7136 16.0445 18.7136H16.0444ZM16.0444 15.5195C16.3391 15.5195 16.6094 15.7898 16.6094 16.1338C16.6094 16.4777 16.3636 16.748 16.0444 16.748C15.7249 16.748 15.4793 16.4777 15.4793 16.1338C15.4791 15.7898 15.7494 15.5195 16.0444 15.5195ZM8.42781 16.748C8.13303 16.748 7.86276 16.4777 7.86276 16.1338C7.86276 15.7898 8.10852 15.5195 8.42781 15.5195C8.74727 15.5195 8.99287 15.7898 8.99287 16.1338C8.99287 16.4777 8.74727 16.748 8.42781 16.748Z"
                                                fill="#E81C2E" />
                                        </svg>


                                        {
                                            totalCartItemsValue ?
                                                <span className='cartValue text-danger'>{totalCartItemsValue}</span> : ""
                                        }
                                        {/* <span className='cartTitle'>Cart</span> */}
                                    </li>

                                    {/* <li className="nav-item text-danger" onClick={showAccountDetails}>
                                        <i className="fa fa-user" aria-hidden="true"></i>
                                    </li> */}

                                    <li className="nav-item text-danger" onClick={redirectToWooCommerce}>
                                        <i className="fa fa-user" aria-hidden="true"></i>
                                    </li>


                                </ul>
                            </div>
                            <div className={`user-template ${showClass ? 'active-user-template' : ""}`}>
                                <div id="nav-al-signin">
                                    <div className="nav-flyout-content nav-flyout-accessibility">
                                        {
                                            loggedIn ?

                                                <div className="my-account">

                                                    <span className="btn btn-sm btn-danger" onClick={redirectToBigCommerce}>My Account</span>
                                                    {/* <span className="btn btn-sm btn-danger" onClick={redirectToProfile}>My Profile</span> */}
                                                    <span className="btn btn-sm btn-danger" onClick={redirectToLogout}>Sign out</span>


                                                </div>

                                                : userEmail ?
                                                    <div className="my-account">

                                                        <span className="btn btn-sm btn-danger" onClick={redirectToBigCommerce}>My Account</span>
                                                        {/* <span className="btn btn-sm btn-danger" onClick={redirectToProfile}>My Profile</span> */}
                                                        <span className="btn btn-sm btn-danger" onClick={redirectToLogout}>Sign out</span>


                                                    </div>
                                                    :
                                                    <>
                                                        <div>
                                                            <span className="nav-action-inner btn btn-danger btn-sm" onClick={openLoginModel}>Sign in
                                                            </span>
                                                        </div>
                                                        <div className="nav_pop_new_cust nav-flyout-content nav-flyout-accessibility">
                                                            <span>New customer?{' '}</span> <span onClick={openRegisterModel} className='text-danger'>Start here.</span>
                                                        </div>

                                                    </>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <Modal show={showModal} onHide={handleClose} size="">
                    <Modal.Header closeButton>
                        <Modal.Title>Select Your Vehicle</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mian-inner-data-tab position-relative">
                            <div className='selectMainDivEditPopup'>
                                Year
                                {
                                    <Select
                                        options={dataYear.data}
                                        onChange={handleYearChange}
                                        placeholder='Year'
                                        value={{ value: selectedYear, label: selectedYear }}
                                        isSearchable={false}
                                    />
                                }
                                {
                                    !isLoading ? "" : <div className="loader"></div>
                                }

                            </div>

                            <div className='selectMainDivEditPopup'>
                                Make
                                {
                                    <Select
                                        menuIsOpen={isOpenMake}
                                        options={dataMake.data}
                                        onChange={handleMakeChange}
                                        openMenuOnClick={true}
                                        placeholder='Make'
                                        // value={{value: vehicalDetails.make, label: vehicalDetails.make_name}}
                                        value={{ value: selectedMake, label: selectedMakeName }}
                                        onMenuOpen={() => setisOpenMake(true)}
                                        onMenuClose={() => setisOpenMake(false)}
                                        isSearchable={false}
                                        ref={makeRef}


                                    />
                                }

                                {isLoaderMake ? "" : <div className="loaderMake"></div>}

                            </div>


                            <div className='selectMainDivEditPopup'>
                                Model
                                {
                                    <Select
                                        menuIsOpen={isOpenModel}
                                        options={dataModel.data}
                                        onChange={handleModelChange}
                                        openMenuOnClick={true}
                                        placeholder='Model'
                                        // value={{value: vehicalDetails.model, label: vehicalDetails.model_name}}
                                        value={{ value: selectedModel, label: selectedModelName }}
                                        onMenuOpen={() => setisOpenModel(true)}
                                        onMenuClose={() => setisOpenModel(false)}
                                        isSearchable={false}
                                        ref={modelRef}
                                    />
                                }
                                {isLoaderModel ? "" : <div className="loaderModel"></div>}


                            </div>


                            <div className='selectMainDivEditPopup'>
                                Sub Model
                                {
                                    <Select
                                        menuIsOpen={isOpenVarient}
                                        options={dataModelVarient.data}

                                        onChange={handleVarientChange}
                                        openMenuOnClick={true}
                                        placeholder='Varient'
                                        // value={{value: vehicalDetails.variant, label: vehicalDetails.variant_name}}
                                        value={{ value: selectedVariant, label: selectedVariantName }}
                                        onMenuOpen={() => setisOpenVarient(true)}
                                        onMenuClose={() => setisOpenVarient(false)}
                                        isOptionSelected={isOptionSelected}
                                        isSearchable={false}
                                        ref={variantRef}
                                    />
                                }
                                {isLoaderVarient ? "" : <div className="loaderVarient"></div>}

                            </div>

                            <div className='selectMainDivEditPopup'>
                                Search History
                                {
                                    <Select
                                        options={vehicalSearchOptions}
                                        onChange={handleVehicalSearchChange}
                                        placeholder='Vehicle Search'
                                        value={{ value: selectedVehicalSearch, label: selectedVehicalSearchName }}
                                        isSearchable={false}
                                    />
                                }
                                {isLoaderAllData ? "" : <div className="loaderAllData"></div>}
                            </div>

                            {/* <div className='selectMainDivEditPopup'>
                                Options
                                <select className='form-control' onChange={handleCheckRedirectionPage} value={searchType}>
                                    <option value="">Select Option</option>
                                    <option value="1">Wheels</option>
                                    <option value="2">Wheels and Accessories</option>
                                </select>
                            </div> */}

                            {
                                !selectedModel ?
                                    <div className="text-right" style={{ textAlign: 'right' }}>
                                        <button className="btn btn-sm btn-danger m-2" disabled>

                                            <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                    fill="white"></path>
                                                <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                    fill="white"></path>
                                                <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                    fill="white"></path>
                                                <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                    fill="white"></path>
                                                <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                    fill="white"></path>
                                            </svg>
                                            Search
                                        </button>
                                    </div>
                                    :
                                    <div className="text-right" style={{ textAlign: 'right' }}>
                                        <button className="btn btn btn-danger srch_btn m-2 " onClick={() => handleShow()} >

                                            <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                    fill="white"></path>
                                                <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                    fill="white"></path>
                                                <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                    fill="white"></path>
                                                <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                    fill="white"></path>
                                                <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                    fill="white"></path>
                                                <path
                                                    d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                    fill="white"></path>
                                            </svg>
                                            <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="img" width="100%" height="100%" />
                                            Search
                                        </button>
                                        <button className="btn btn btn-danger restButton" onClick={() => handleResetInputs()} >
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                            Reset
                                        </button>
                                    </div>

                            }
                        </div>


                    </Modal.Body>
                </Modal>

                <Modal show={showLoginModel} onHide={handleClose} size="">
                    <Modal.Header closeButton  >
                        <strong className='heading'>Sign in</strong>
                    </Modal.Header>
                    <Modal.Body>

                        <div className='form-main-div'>

                            <form onSubmit={handleSubmit}>
                                {/* <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email:</label>
                                    <div className="input-group"> 
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    />
                                      <div className="input-group-append"> 
                                        <span>
                                    <i className="fa fa-envelope" aria-hidden="true"></i>
                                    </span>
                                        </div>
                                    </div>
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </div> */}
                                <div className="mb-3" >
                                    <label htmlFor="email" className="form-label">Email:</label>
                                    <div className="input-group">
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5'
                                        }}>
                                            <span>
                                                <i className="toggle-password text-danger fa fa-envelope"></i>
                                            </span>
                                        </div>
                                    </div>

                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </div>
                                <div className="" >
                                    <label htmlFor="password" className="form-label">Password:</label>
                                    <div className="input-group">
                                        <input
                                            type={setShowPasswordSigin ? "text" : "password"}
                                            id="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}

                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5', bottom: '2'
                                        }}>
                                            <span onClick={togglePasswordVisibilitySignin}>
                                                <i
                                                    className={`toggle-password fa fa-fw ${setShowPasswordSigin ? 'fa-eye' : 'fa-eye-slash'} text-danger`}

                                                ></i>
                                            </span>
                                        </div>
                                    </div>

                                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                </div>
                                <div className='forgetPasswordLink mb-3'>
                                    <span>
                                        Forgot  Password  <a href='/forgot-password'>click here</a>
                                    </span>
                                </div>

                                {/* <button type="submit" className="btn btn-danger">Sign In</button> */}
                                {
                                    !isSubmitting ?
                                        <button type="submit" className="btn btn-danger" >Sign In</button>
                                        :
                                        <button type="submit" className="btn btn-danger loading" disabled></button>
                                }

                            </form>

                            {/* <div className="a-divider-inner"></div> */}
                            {/* <span className='span-login'>New customer?{' '}<a href="register" rel="nofollow" className="nav-a" > Start here. </a> </span> */}
                        </div>
                    </Modal.Body>
                </Modal>


                <Modal show={showRegisterModel} onHide={handleClose} size="">
                    <Modal.Header closeButton  >
                        <strong className='heading'>Create Account</strong>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='form-main-div'>

                            <form onSubmit={handleSubmitRegister}>
                                <div className="mb-3">
                                    <label htmlFor="firstName" className="form-label">First Name:</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            id="firstName"
                                            name="firstName"
                                            value={formDataRegister.firstName}
                                            onChange={handleChangeRegister}
                                            className={`form-control ${newErrors.firstName ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5'
                                        }}>
                                            <span>
                                                <i className="fa fa-user toggle-password text-danger"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {newErrors.firstName && <div className="invalid-feedback">{newErrors.firstName}</div>}

                                    <label htmlFor="lastName" className="form-label">Last Name:</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            id="lastName"
                                            name="lastName"
                                            value={formDataRegister.lastName}
                                            onChange={handleChangeRegister}
                                            className={`form-control ${newErrors.lastName ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5'
                                        }}>
                                            <span>
                                                <i className="fa fa-user toggle-password text-danger"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {newErrors.lastName && <div className="invalid-feedback">{newErrors.lastName}</div>}


                                    <label htmlFor="username" className="form-label">User Name:</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            id="username"
                                            name="username"
                                            value={formDataRegister.username}
                                            onChange={handleChangeRegister}
                                            className={`form-control ${newErrors.username ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5'
                                        }}>
                                            <span>
                                                <i className="fa fa-user toggle-password text-danger"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {newErrors.username && <div className="invalid-feedback">{newErrors.username}</div>}


                                    <label htmlFor="email" className="form-label">Email:</label>
                                    <div className="input-group">
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formDataRegister.email}
                                            onChange={handleChangeRegister}
                                            className={`form-control ${newErrors.email ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5'
                                        }}>
                                            <span>
                                                <i className="toggle-password text-danger fa fa-envelope"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {newErrors.email && <div className="invalid-feedback">{newErrors.email}</div>}


                                    <label htmlFor="password" className="form-label">Password:</label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            name="password"
                                            value={formDataRegister.password}

                                            onChange={(e) => {
                                                handleChangeRegister(e);
                                                // Clear the password error when the user starts typing a new password
                                                if (newErrors.password) {
                                                    setErrors({ ...newErrors, password: '' });
                                                }
                                            }}
                                            className={`form-control ${newErrors.password ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5', bottom: '2'
                                        }}>
                                            <span onClick={togglePasswordVisibility}>
                                                <i
                                                    className={`toggle-password fa fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} text-danger`}

                                                ></i>
                                            </span>
                                        </div>
                                    </div>

                                    {/* <i className="toggle-password fa fa-fw fa-eye-slash text-danger" onClick={togglePasswordVisibility}></i> */}
                                    {newErrors.password && <div className="invalid-feedback">{newErrors.password}</div>}


                                    <label htmlFor="confirmPassword" className="form-label">Confirm Password:</label>
                                    <div className="input-group">
                                        <input
                                            type={showPasswordConfirm ? "text" : "password"}
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            value={formDataRegister.confirmPassword}

                                            onChange={(e) => {
                                                handleChangeRegister(e);
                                                // Clear the password error when the user starts typing a new password
                                                if (newErrors.confirmPassword) {
                                                    setErrors({ ...newErrors, confirmPassword: '' });
                                                }
                                            }}
                                            className={`form-control ${newErrors.confirmPassword ? 'is-invalid' : ''}`}
                                        />
                                        <div className="input-group-append" style={{
                                            position: 'absolute', right: '0', zIndex: '5', bottom: '2'
                                        }}>
                                            <span onClick={togglePasswordVisibilityConfirm}>
                                                <i
                                                    className={`toggle-password fa fa-fw ${showPasswordConfirm ? 'fa-eye' : 'fa-eye-slash'} text-danger`}

                                                ></i>
                                            </span>
                                        </div>
                                    </div>
                                    {/* <i className="toggle-password fa fa-fw fa-eye-slash text-danger" onClick={togglePasswordVisibilityConfirm}></i> */}
                                    {newErrors.confirmPassword && <div className="invalid-feedback">{newErrors.confirmPassword}</div>}

                                    <div style={{ fontSize: '10px', color: 'red', lineHeight: '1' }}><spna style={{ fontSize: '10px', color: 'red' }}>Password must be at least 8 characters long and contain atleast an uppercase letter, a lowercase letter, a number, and a special character</spna></div>
                                </div>
                                {
                                    !isSubmitting ?
                                        <button type="submit" className="btn btn-danger" >Register</button>
                                        :
                                        <button type="submit" className="btn btn-danger loading" disabled></button>
                                }




                                {/* <button type="submit" className="btn btn-danger" disabled={isSubmitting}>{isSubmitting ? 'Loading...' : 'Register'}</button>
                                <button type="submit" className="btn btn-danger" disabled={isSubmitting}>{isSubmitting ? 'Loading...' : 'Register'}</button> */}
                            </form>

                            <div className="a-divider-inner"></div>
                            {/* <span className='span-login'>Already have an account?<a href="login" rel="nofollow" className="nav-a">Sign in.</a> </span> */}
                        </div>
                    </Modal.Body>
                </Modal>
            </section>
            {/* <!-- header end --> */}
        </div >
    )
}
